import React from "react";
import { Button, ButtonGroup, Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';
import { AlternateEmail, Link, Phone, WhatsApp } from "@mui/icons-material";
import __t from "../../lib/traduzioni";
import BSSSnackbar from "../form/BSSSnackbar";

const _AlertNoQuotations = ({noQuotationsContacts}) => {

    return (
        <Alert severity="error"
            action={
                Object.values(noQuotationsContacts).findIndex(v => v !== null) !== -1 && (
                    <ButtonGroup variant="text" color="primary">
                        {Object.keys(noQuotationsContacts).map(nomecontatto => {

                            const contatto = noQuotationsContacts[nomecontatto];
                            
                            const Comp = nomecontatto === "mail" ? 
                                AlternateEmail : 
                                nomecontatto === "tel" ? 
                                    Phone : 
                                    nomecontatto === "whatsapp" ?
                                        WhatsApp  :
                                        Link
                            
                            const link = nomecontatto === "mail" ? 
                            `mailto:${contatto}` : 
                            nomecontatto === "tel" ? 
                                `tel:${contatto}` : 
                                nomecontatto === "whatsapp" ?
                                    `https://wa.me/${contatto}`  :
                                    `${contatto}`

                            return contatto === null ? "" : (
                                <Button onClick={e => window.open(link, '_blank')}>
                                    <Comp />
                                </Button>
                            )
                        })}
                    </ButtonGroup>
                )                                            
            }
        >
            {__t("nessunaquotazione")}
            {" "}
            {Object.values(noQuotationsContacts).findIndex(v => v !== null) !== -1 && __t("contattaci")}
        </Alert>
    )
}

const AlertNoQuotations = ({noQuotationsContacts, inSnackbar = false, mostraNessunPreventivo = false, setMostraNessunPreventivo}) => {
    return inSnackbar ? (
        <BSSSnackbar open={mostraNessunPreventivo} autoHideDuration={12000} onClose={e => setMostraNessunPreventivo(false)}>
            <_AlertNoQuotations noQuotationsContacts={noQuotationsContacts} />
        </BSSSnackbar>
    ) : (
        <_AlertNoQuotations noQuotationsContacts={noQuotationsContacts} />
    )
}

export default AlertNoQuotations